import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { FIRM } from "@/constants/firmInfo";
import { useLanguage } from "@/i18n/LanguageContext";

// Fixed bottom action bar visible only on mobile/tablet (<lg) for quick
// click-to-call, WhatsApp, and consultation scheduling access.
export const MobileFloatingCTA = () => {
  const { t } = useLanguage();
  const digits = FIRM.phoneTel.replace(/[^0-9]/g, "");
  const waMessage = encodeURIComponent("Hi Rinnou & Associates, I'd like to ask about a legal matter.");

  return (
    <div
      className="fixed bottom-3 left-3 right-3 z-50 lg:hidden"
      data-testid="mobile-floating-cta-bar"
    >
      <div className="grid grid-cols-3 gap-1.5 rounded-2xl bg-[color:var(--navy-950)]/97 backdrop-blur border border-white/10 shadow-[0_18px_50px_rgba(11,18,32,0.4)] p-1.5">
        <a
          href={`tel:${FIRM.phoneTel}`}
          className="flex flex-col items-center justify-center gap-0.5 rounded-xl h-14 text-[11px] font-semibold text-white hover:bg-white/10 transition-colors"
          data-testid="mobile-call-now-button"
        >
          <Phone className="h-4 w-4 text-[color:var(--gold-400)]" />
          {t("mobileCta.call")}
        </a>
        <a
          href={`https://wa.me/${digits}?text=${waMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-0.5 rounded-xl h-14 text-[11px] font-semibold text-white hover:bg-white/10 transition-colors"
          data-testid="mobile-whatsapp-button"
        >
          <MessageCircle className="h-4 w-4 text-[#25D366]" />
          {t("mobileCta.whatsapp")}
        </a>
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center gap-0.5 rounded-xl h-14 text-[11px] font-semibold text-[color:var(--navy-950)] bg-[color:var(--gold-500)] hover:bg-[color:var(--gold-400)] transition-colors"
          data-testid="mobile-schedule-consultation-button"
        >
          <CalendarCheck className="h-4 w-4" />
          {t("mobileCta.schedule")}
        </Link>
      </div>
    </div>
  );
};
